// Utility to match tracks between source and destination playlists
// Returns an array of source tracks with matchConfidence and potentialMatches

function normalize(str) {
  return str.toLowerCase().replace(/[^a-z0-9]/g, '');
}

function getConfidence(src, dst) {
  if (!src.title || !dst.title || !src.artist || !dst.artist) return 0;
  const titleMatch = normalize(src.title) === normalize(dst.title);
  const artistMatch = normalize(src.artist) === normalize(dst.artist);
  const durationMatch = Math.abs((src.duration || 0) - (dst.duration || 0)) < 2;
  if (titleMatch && artistMatch && durationMatch) return 1.0;
  // Fuzzy: partial title/artist, duration within 10s
  const titleSimilar = normalize(src.title).includes(normalize(dst.title)) || normalize(dst.title).includes(normalize(src.title));
  const artistSimilar = normalize(src.artist).includes(normalize(dst.artist)) || normalize(dst.artist).includes(normalize(src.artist));
  const durationSimilar = Math.abs((src.duration || 0) - (dst.duration || 0)) < 10;
  if (titleSimilar && artistSimilar && durationSimilar) return 0.8;
  // Only partial match
  if ((titleSimilar || artistSimilar) && durationSimilar) return 0.6;
  return 0;
}

export function matchTracks(sourceTracks, destinationTracks) {
  return sourceTracks.map(src => {
    let bestMatch = null;
    let bestConfidence = 0;
    let potentialMatches = [];
    destinationTracks.forEach(dst => {
      const confidence = getConfidence(src, dst);
      if (confidence > bestConfidence) {
        bestConfidence = confidence;
        bestMatch = dst;
      }
      if (confidence >= 0.6) {
        potentialMatches.push({ ...dst, confidence });
      }
    });
    return {
      ...src,
      matchConfidence: bestConfidence,
      matchedTrack: bestMatch,
      potentialMatches: potentialMatches.length > 0 ? potentialMatches : null,
    };
  });
} 